import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FontsService {
  private readonly nonCriticalFonts = [
    {
      name: 'Proxima Nova Bold Italic',
      url: 'assets/fonts/ProximaNova-BoldIt.woff2',
    },
  ];

  loadNonCriticalFonts(): void {
    this.nonCriticalFonts.forEach((font) => {
      const fontFace = new FontFace(font.name, `url(${font.url})`);

      (document.fonts as any).add(fontFace);
      fontFace
        .load()
        .then(() => {})
        .catch(() => {});
    });
  }
}
